import { ptax } from '@/proto/proto';
import { colors, messages } from '@/components/covalent/tax/notice/TaxNoticeStatus';
import { Tag } from 'antd';

type TaxChangeRequestStatusProps = {
  data?: ptax.IPbTaxNotice;
};

const TaxNoticeStatusText = ({ data }: TaxChangeRequestStatusProps) => {
  return (
    <Tag style={{ margin: 0 }} className={colors(data?.type ?? -1, data?.status ?? -1)}>
      {messages(data?.status ?? -1)}
    </Tag>
  );
};

TaxNoticeStatusText.defaultProps = {
  data: undefined,
};

export default TaxNoticeStatusText;
